import { render, staticRenderFns } from "./closeDialog.vue?vue&type=template&id=4c1351a5&scoped=true"
import script from "./closeDialog.vue?vue&type=script&lang=js"
export * from "./closeDialog.vue?vue&type=script&lang=js"
import style0 from "./closeDialog.vue?vue&type=style&index=0&id=4c1351a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1351a5",
  null
  
)

export default component.exports